/**
 * Button With Content Component generates a button block with text above it.
 */
import React from 'react';
import { ButtonWithContentCard, ButtonWithContentSection } from './layouts';
import '../styles/index.scss';
var defaultProps = {
  brand: 'law',
  heading: null,
  content: null,
  subContent: null,
  buttonLabel: '',
  buttonType: 'primary',
  url: '',
  anchorLink: null,
  card: false,
  hasBackground: false
};

/**
 * Button With Content React Component
 *
 * @param  {string} brand => The brand
 * @param  {node} heading => The content title, optional
 * @param  {node} content => The content text, required
 * @param  {node} subContent => Additional content text (below the button), optional
 * @param  {string} buttonLabel => The text displayed within the button
 * @param  {string} buttonType => The button variant, primary and secondary
 * @param  {string} url => The url which clicking the button will take the user
 * @param  {node} anchorLink => A gatsby anchor link if the link is to an id in contentful
 * @param  {boolean} card => Whether the button with content is intended to go in a card section
 * @param  {boolean} hasBackground => Set the background color
 */
var ButtonWithContent = function ButtonWithContent(_ref) {
  var brand = _ref.brand,
    heading = _ref.heading,
    content = _ref.content,
    subContent = _ref.subContent,
    buttonLabel = _ref.buttonLabel,
    buttonType = _ref.buttonType,
    url = _ref.url,
    anchorLink = _ref.anchorLink,
    card = _ref.card,
    hasBackground = _ref.hasBackground;
  return /*#__PURE__*/React.createElement(React.Fragment, null, card ? /*#__PURE__*/React.createElement(ButtonWithContentCard, {
    brand: brand,
    heading: heading,
    content: content,
    subContent: subContent,
    buttonLabel: buttonLabel,
    buttonType: buttonType,
    url: url,
    anchorLink: anchorLink
  }) : /*#__PURE__*/React.createElement(ButtonWithContentSection, {
    brand: brand,
    heading: heading,
    content: content,
    subContent: subContent,
    buttonLabel: buttonLabel,
    buttonType: buttonType,
    url: url,
    anchorLink: anchorLink
  }));
};
ButtonWithContent.defaultProps = defaultProps;
export { ButtonWithContent };